import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductService } from '../services/product.service';

@Component({
  standalone: false,
  selector: 'app-mockup-page',
  templateUrl: './mockup-page.component.html',
  styleUrls: ['./mockup-page.component.scss']
})
export class MockupPageComponent implements OnInit {

  products = this.productService.getProducts()
  currentUrl = this.router.url
  staticImageURL = this.getStaticImageURL();
  productTitle = this.getProductTitle();
  imgAlt = this.getProductTitle().toLowerCase().split(' ').join('-')

  constructor(private productService: ProductService, private router: Router) {
    // console.log(this.products.filter((i) => i.staticImage.includes(this.currentUrl)))
  }

  getProductTitle() {
    if (this.products.filter((i) => i.staticImage.includes(this.currentUrl))) {
      return this.products.filter((i) => i.staticImage.includes(this.currentUrl))[0].name
    } else {
      return ''
    }
  }

  getStaticImageURL() {
    if (this.products.filter((i) => i.staticImage.includes(this.currentUrl))) {
      return this.products.filter((i) => i.staticImage.includes(this.currentUrl))[0].staticImage
    } else {
      return ''
    }
  }

  ngOnInit(): void {
  }

}
